import { FC } from "react";
import { Flex, Skeleton } from "@chakra-ui/react";

export const BaseTableFiltersSkeleton: FC = () => {
  return (
    <Flex justifyContent="space-between" backgroundColor="white" padding="24px" borderRadius="8px" border="1px solid #e1e7ef">
      <Flex gap="24px" alignItems="center">
        <Skeleton height="40px" width="309px" borderRadius="6px" />
        <Skeleton height="40px" width="300px" borderRadius="6px" />
        <Skeleton height="40px" width="100px" borderRadius="6px" />
      </Flex>
      <Skeleton height="40px" width="100px" borderRadius="6px" />
    </Flex>
  );
};
